
import React from "react";

/* --------------------------------------------------------------
   Primary Component – renders the “合作要求与支持” section.
   This component remains the default export.
-------------------------------------------------------------- */
export default function RequirementsSection() {
  const requirements = [
    {
      type: "区域代理商",
      conditions: [
        "具备一定的资金实力，启动资金10万元以上",
        "拥有当地优质的销售渠道或客户资源",
        "对茶叶行业有一定了解，认同品牌理念",
        "具备团队管理经验，能够独立运营区域市场",
        "承诺专心经营，不代理同类竞品",
      ],
      support: [
        "独家区域代理权保护",
        "最优价格政策支持",
        "市场推广费用补贴",
        "专业培训和运营指导",
        "年度激励政策奖励",
      ],
    },
    {
      type: "零售合作商",
      conditions: [
        "有实体店面或成熟的销售渠道",
        "启动资金2万元以上",
        "热爱茶文化，愿意学习产品知识",
        "具备基本的销售能力和服务意识",
        "能够配合品牌统一的营销活动",
      ],
      support: [
        "灵活的进货政策",
        "营销物料免费提供",
        "产品知识专业培训",
        "销售技巧指导支持",
        "节假日促销活动支持",
      ],
    },
    {
      type: "电商合作伙伴",
      conditions: [
        "拥有稳定的粉丝基础，粉丝量1万以上",
        "直播或短视频内容质量优秀",
        "具备一定的带货经验和能力",
        "能够保证每月固定的直播场次",
        "愿意深度了解产品，做好客户服务",
      ],
      support: [
        "专业的选品和定价指导",
        "直播脚本和话术培训",
        "实时数据分析和优化建议",
        "优质产品优先推广权",
        "月度销售激励奖金",
      ],
    },
    {
      type: "品牌加盟店",
      conditions: [
        "具备充足的资金实力，总投资20万以上",
        "拥有优质的商圈位置和店面资源",
        "认同品牌文化，愿意长期合作发展",
        "具备零售管理经验或相关从业背景",
        "能够严格执行品牌统一标准",
      ],
      support: [
        "完整的品牌形象授权",
        "店面设计和装修指导",
        "开业前全方位培训",
        "持续的运营管理支持",
        "区域保护政策",
      ],
    },
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-orange-50 via-amber-50 to-yellow-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* 标题区域 */}
        <div className="text-center mb-16">
          <h2 className="text-2xl sm:text-4xl font-bold text-[#663333] mb-4">
            合作要求与支持
          </h2>
          <div className="w-24 h-1 bg-[#cc9966] mx-auto mb-6" />
          <p className="text-sm sm:text-xl text-gray-600 max-w-3xl mx-auto">
            明确的合作标准，完善的支持体系，确保每一位合作伙伴都能获得成功
          </p>
        </div>

        {/* 各类合作要求卡片 */}
        <div className="space-y-12">
          {requirements.map((req, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg"
              aria-labelledby={`req-title-${index}`}
            >
              <h3
                id={`req-title-${index}`}
                className="text-lg sm:text-2xl font-bold text-[#663333] mb-8 text-center"
              >
                {req.type}
              </h3>

              <div className="grid lg:grid-cols-2 gap-8">
                {/* 合作条件 */}
                <div>
                  <h4 className="text-base sm:text-xl font-semibold text-[#663333] mb-6 flex items-center">
                    <div className="w-6 h-6 bg-[#cc9966] rounded-full flex items-center justify-center mr-3">
                      <i className="ri-checkbox-circle-line text-white text-sm" />
                    </div>
                    合作条件
                  </h4>
                  <ul className="space-y-3">
                    {req.conditions.map((condition, cIndex) => (
                      <li
                        key={cIndex}
                        className="flex items-start space-x-3"
                      >
                        <div className="w-2 h-2 bg-[#cc9966] rounded-full mt-2 flex-shrink-0" />
                        <span className="text-xs sm:text-base text-gray-700 leading-relaxed">
                          {condition}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* 支持政策 */}
                <div>
                  <h4 className="text-base sm:text-xl font-semibold text-[#663333] mb-6 flex items-center">
                    <div className="w-6 h-6 bg-[#663333] rounded-full flex items-center justify-center mr-3">
                      <i className="ri-gift-line text-white text-sm" />
                    </div>
                    支持政策
                  </h4>
                  <ul className="space-y-3">
                    {req.support.map((support, sIndex) => (
                      <li key={sIndex} className="flex items-start space-x-3">
                        <div className="w-2 h-2 bg-[#663333] rounded-full mt-2 flex-shrink-0" />
                        <span className="text-xs sm:text-base text-gray-700 leading-relaxed">
                          {support}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* 申请流程 */}
        <div className="mt-16 bg-white rounded-2xl p-8 shadow-lg">
          <h3 className="text-lg sm:text-2xl font-bold text-[#663333] mb-8 text-center">
            申请流程
          </h3>

          <div className="grid md:grid-cols-4 gap-6">
            {[
              {
                step: "1",
                title: "提交申请",
                desc: "填写合作申请表，提交相关资质材料",
              },
              {
                step: "2",
                title: "资质审核",
                desc: "3-5个工作日内完成资质审核和实地考察",
              },
              {
                step: "3",
                title: "签署协议",
                desc: "双方达成合作意向，签署正式合作协议",
              },
              {
                step: "4",
                title: "正式合作",
                desc: "开始正式合作，享受全方位支持服务",
              },
            ].map((item, i) => (
              <div key={i} className="text-center">
                <div className="w-12 h-12 bg-[#cc9966] rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-white font-bold">{item.step}</span>
                </div>
                <h4 className="text-sm sm:text-base font-semibold text-[#663333] mb-2">
                  {item.title}
                </h4>
                <p className="text-xs sm:text-sm text-gray-600">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

/* --------------------------------------------------------------
   Secondary Component – renders the “合作要求” & “支持服务”
   This component is exported as a named export to avoid a
   duplicate default export.
-------------------------------------------------------------- */
export function RequirementsDetails() {
  const requirements = [
    {
      icon: "ri-user-3-line",
      title: "个人条件",
      items: [
        "年满18周岁，具有完全民事行为能力",
        "有一定的电商或销售经验优先",
        "具备基本的网络操作能力",
        "有创业激情和学习能力",
      ],
    },
    {
      icon: "ri-building-line",
      title: "企业条件",
      items: [
        "合法注册的企业法人",
        "具备相应的经营范围",
        "有一定的资金实力",
        "拥有专业的运营团队",
      ],
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "资金要求",
      items: [
        "电商合作伙伴：0启动资金",
        "区域代理商：20-50万投资预算",
        "零售合作商：1-10万进货资金",
        "品牌加盟店：10-30万投资资金",
      ],
    },
    {
      icon: "ri-heart-3-line",
      title: "合作理念",
      items: [
        "认同顺年陈品牌文化和价值观",
        "诚信经营，维护品牌形象",
        "积极配合总部的统一管理",
        "致力于长期合作发展",
      ],
    },
  ];

  const supportServices = [
    {
      icon: "ri-book-open-line",
      title: "培训支持",
      description:
        "提供全面的产品知识、销售技巧、运营管理培训",
    },
    {
      icon: "ri-palette-line",
      title: "物料支持",
      description: "提供宣传物料、产品图片、营销素材等",
    },
    {
      icon: "ri-customer-service-2-line",
      title: "运营支持",
      description: "专业运营团队提供一对一指导服务",
    },
    {
      icon: "ri-shield-check-line",
      title: "品质支持",
      description: "严格的品质控制体系，确保产品质量",
    },
    {
      icon: "ri-truck-line",
      title: "物流支持",
      description: "完善的物流体系，24小时快速发货",
    },
    {
      icon: "ri-line-chart-line",
      title: "数据支持",
      description: "提供实时销售数据和市场分析报告",
    },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-2xl sm:text-4xl font-bold text-[#663333] mb-4">
            合作要求
          </h2>
          <div className="w-24 h-1 bg-[#cc9966] mx-auto mb-6" />
          <p className="text-sm sm:text-xl text-gray-600 max-w-3xl mx-auto">
            我们寻找志同道合的合作伙伴，共同打造茶业品牌，实现互利共赢
          </p>
        </div>

        {/* 合作要求卡片 */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-20">
          {requirements.map((req, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
            >
              <div className="text-center mb-6">
                <div className="w-14 h-14 bg-gradient-to-br from-[#cc9966] to-[#b8865a] rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${req.icon} text-xl text-white`} />
                </div>
                <h3 className="text-base sm:text-lg font-bold text-[#663333]">
                  {req.title}
                </h3>
              </div>
              <ul className="space-y-3">
                {req.items.map((item, idx) => (
                  <li key={idx} className="flex items-start space-x-2">
                    <i className="ri-check-line text-[#cc9966] text-xs mt-0.5 flex-shrink-0" />
                    <span className="text-xs sm:text-sm text-gray-600 leading-relaxed">
                      {item}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* 支持服务 */}
        <div>
          <h3 className="text-xl sm:text-2xl font-bold text-[#663333] text-center mb-12">
            我们提供的支持
          </h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {supportServices.map((service, index) => (
              <div
                key={index}
                className="bg-white border border-gray-200 rounded-xl p-6 text-center hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
              >
                <div className="w-12 h-12 bg-gradient-to-br from-[#cc9966] to-[#b8865a] rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${service.icon} text-lg text-white`} />
                </div>
                <h4 className="text-sm sm:text-base font-bold text-[#663333] mb-3">
                  {service.title}
                </h4>
                <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
                  {service.description}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* 申请提示 */}
        <div className="mt-16 bg-gradient-to-r from-[#663333] to-[#552222] rounded-2xl p-8 text-white text-center">
          <h3 className="text-lg sm:text-xl font-bold mb-4">
            准备好开始了吗？
          </h3>
          <p className="text-xs sm:text-base mb-6 opacity-90">
            满足以上条件的朋友，欢迎提交合作申请，我们将在24小时内联系您
          </p>
          <button
            type="button"
            className="bg-[#cc9966] text-[#663333] px-8 py-3 rounded-lg font-semibold text-sm sm:text-base hover:bg-[#b8865a] transition-colors duration-300 whitespace-nowrap cursor-pointer"
            onClick={() => {
              try {
                // Placeholder for real navigation / modal opening logic.
                alert("申请按钮已点击，后续可接入表单或路由跳转。");
              } catch (err) {
                console.error("申请按钮处理出现错误:", err);
              }
            }}
          >
            立即申请合作
          </button>
        </div>
      </div>
    </section>
  );
}
